module.exports = __webpack_public_path__ + "static/media/BBs_drinks_back.7ebc3664.png";